<template>
    <Card>
        <div class="card-body">
            <router-link
                class="btn btn-link legitRipple"
                :to="{
                    name: 'CreateApiCredentialsPage'
                }"
            >
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </router-link>
        </div>
        <FetchTable
            :handle="tableHandle"
            :url="table.url"
            :columns="table.columns"
        >
            <template #td-id="{row}">
                <router-link :to="{
                    name: 'EditApiCredentialsPage',
                    params: {
                        apiCredentialUuid: row.uuid
                    }
                }">
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-service="{row}">
                {{ integrationServices[row.service] }}
            </template>
            <template #td-is_active="{row}">
                <span :class="['badge', row.is_active ? 'bg-success' : 'bg-danger']" style="color: white">
                    {{ row.is_active ? $t('labels.active') : $t('labels.inactive') }}
                </span>
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FetchTable from '../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../components/new/table/tableHandle';
import AppButton from '../../../../components/new/button/AppButton.vue';

import { ApiCredentialsServiceEnum } from '../../../enums/ApiCredentialsServiceEnum';

export default {
    name: "IndexApiCredentialsPage",
    components: {
        Card, FetchTable, AppButton
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            table: {
                url: `/projects/${this.$route.params.projectUuid}/core/api-credentials`,
                columns: [
                    { key: 'id', name: this.$t('table.titles.id'), width: '80px', type: 'string', order: false },
                    { key: 'name', name: this.$t('table.titles.name'), width: '150px', type: 'string', order: false },
                    { key: 'service', name: this.$t('table.titles.service'), width: '150px', type: 'string', order: false },
                    { key: 'is_active', name: this.$t('table.titles.status'), width: '150px', type: 'string', order: false },
                ]
            },
            integrationServices: {
                [`${ApiCredentialsServiceEnum.EPICENTR}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.EPICENTR}`),
                [`${ApiCredentialsServiceEnum.KASTA}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.KASTA}`),
                [`${ApiCredentialsServiceEnum.HOROSHOP}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.HOROSHOP}`),
                [`${ApiCredentialsServiceEnum.SHOP_EXPRESS}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.SHOP_EXPRESS}`),
                [`${ApiCredentialsServiceEnum.ROZETKA}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.ROZETKA}`),
                [`${ApiCredentialsServiceEnum.PROM}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.PROM}`),
                [`${ApiCredentialsServiceEnum.WOOCOMMERCE}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.WOOCOMMERCE}`),
                [`${ApiCredentialsServiceEnum.MAUDAU}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.MAUDAU}`),
                [`${ApiCredentialsServiceEnum.INTEL_TELE}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.INTEL_TELE}`),
                [`${ApiCredentialsServiceEnum.EVA}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.EVA}`),
                [`${ApiCredentialsServiceEnum.ALLO}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.ALLO}`),
                [`${ApiCredentialsServiceEnum.NOVAPOST}`]: this.$t(`integrationServices.${ApiCredentialsServiceEnum.NOVAPOST}`)
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows();
    }
}
</script>
